/*
 * @Date: 2020-02-26 02:23:13
 * @LastEditors: wxb
 * @LastEditTime: 2020-02-26 02:28:26
 * @FilePath: \ui-portal\src\views\Company\components\bus.js
 * @describe: 非父子组件进行传值
 */
import Vue from 'vue'
export default new Vue()
